import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  MinusCircleIcon,
} from '@heroicons/react/24/outline';

import { LoadingSpinner } from 'components/Loading/LoadingSpinner';

export type StatusBubbleVariant = 'error' | 'warning' | 'fixed' | 'pending' | 'validating';

type StatusBubbleIconProps = {
  variant: StatusBubbleVariant;
};

const variantClasses: Record<StatusBubbleVariant, { bg: string; icon: string }> = {
  error: { bg: 'bg-red-50', icon: 'text-red-500' },
  warning: { bg: 'bg-amber-50', icon: 'text-amber-500' },
  fixed: { bg: 'bg-green-50', icon: 'text-green-500' },
  pending: { bg: 'bg-blue-50', icon: 'text-blue-500' },
  validating: { bg: 'bg-blue-50', icon: 'text-blue-500' },
};

export const StatusBubble = ({ variant }: { variant: StatusBubbleVariant }) => {
  const { bg, icon } = variantClasses[variant];
  return (
    <div
      aria-hidden="true"
      data-testid={`status-bubble-${variant}`}
      className={`flex shrink-0 items-center justify-center rounded-full p-[6px] ${bg} ${icon}`}
    >
      <StatusBubbleIcon variant={variant} />
    </div>
  );
};

const StatusBubbleIcon = ({ variant }: StatusBubbleIconProps) => {
  switch (variant) {
    case 'error':
      return <ExclamationCircleIcon className="size-5" />;
    case 'warning':
      return <ExclamationTriangleIcon className="size-5" />;
    case 'fixed':
      return <CheckCircleIcon className="size-5" />;
    case 'pending':
      return <MinusCircleIcon className="size-5" />;
    case 'validating':
      return <LoadingSpinner sizeClassName="size-5" />;
  }
};
